export const formatFileNamePart = (name: string | null, phone: string | null): string => {
  return name ?? phone ?? '不明';
};
